
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 31 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.402.42c-8.1 0-14.7 6.5-14.7 14.6s6.6 14.7 14.7 14.7 14.7-6.6 14.7-14.7c-.1-8.1-6.6-14.6-14.7-14.6z","fill":"#fff","stroke":"#515358","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M20.8 11.9c-1.7-2.9-5.5-4-8.4-2.3-1.1.6-1.9 1.5-2.4 2.6-.1-1.7.2-3.4.8-5H9.1c-1.2 3.5-.9 7.4 1 10.8.8 1.5 2.2 2.5 3.7 2.9 1.5.4 3.2.2 4.7-.6 1.1-.6 1.9-1.5 2.4-2.6.1 1.7-.2 3.4-.8 5h1.6c1.3-3.5 1.1-7.4-.9-10.8zm-3 7.1c-2.2 1.3-5 .5-6.3-1.7-.1-.2-.2-.3-.2-.5-.9-2.1-.1-4.7 1.9-5.9 2.2-1.3 5-.5 6.3 1.7.1.2.2.3.2.5 1 2.2.2 4.7-1.9 5.9zm-2.3-5.5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5S14 15.8 14 15s.7-1.5 1.5-1.5m0-1.6c-1.7 0-3.1 1.4-3.1 3.1s1.4 3.1 3.1 3.1 3.1-1.4 3.1-3.1-1.4-3.1-3.1-3.1z","fill":"#515358"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/tools_svgs/slack.svg